"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSIMOCO = void 0;
exports.ASSIMOCO = {
    AGRIGENTO: {
        regionCode: 'AG',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Agrigento',
    },
    ALESSANDRIA: {
        regionCode: 'AL',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Alessandria',
    },
    ANCONA: {
        regionCode: 'AN',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Ancona',
    },
    AOSTA: {
        regionCode: 'AO',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Aosta',
    },
    "L'AQUILA": {
        regionCode: 'AQ',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: "L'aquila",
    },
    AREZZO: {
        regionCode: 'AR',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Arezzo',
    },
    'ASCOLI-PICENO': {
        regionCode: 'AP',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Ascoli-piceno',
    },
    ASTI: {
        regionCode: 'AT',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Asti',
    },
    AVELLINO: {
        regionCode: 'AV',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Avellino',
    },
    BARI: {
        regionCode: 'BA',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Bari',
    },
    'BARLETTA-ANDRIA-TRANI': {
        regionCode: 'BT',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Barletta-andria-trani',
    },
    BELLUNO: {
        regionCode: 'BL',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Belluno',
    },
    BENEVENTO: {
        regionCode: 'BN',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Benevento',
    },
    BERGAMO: {
        regionCode: 'BG',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Bergamo',
    },
    BIELLA: {
        regionCode: 'BI',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Biella',
    },
    BOLOGNA: {
        regionCode: 'BO',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Bologna',
    },
    BOLZANO: {
        regionCode: 'BZ',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Bolzano',
    },
    BRESCIA: {
        regionCode: 'BS',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Brescia',
    },
    BRINDISI: {
        regionCode: 'BR',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Brindisi',
    },
    CAGLIARI: {
        regionCode: 'CA',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Cagliari',
    },
    CALTANISSETTA: {
        regionCode: 'CL',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Caltanissetta',
    },
    CAMPOBASSO: {
        regionCode: 'CB',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Campobasso',
    },
    'CARBONIA IGLESIAS': {
        regionCode: 'CI',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Carbonia Iglesias',
    },
    CASERTA: {
        regionCode: 'CE',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Caserta',
    },
    CATANIA: {
        regionCode: 'CT',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Catania',
    },
    CATANZARO: {
        regionCode: 'CZ',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Catanzaro',
    },
    CHIETI: {
        regionCode: 'CH',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Chieti',
    },
    COMO: {
        regionCode: 'CO',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Como',
    },
    COSENZA: {
        regionCode: 'CS',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Cosenza',
    },
    CREMONA: {
        regionCode: 'CR',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Cremona',
    },
    CROTONE: {
        regionCode: 'KR',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Crotone',
    },
    CUNEO: {
        regionCode: 'CN',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Cuneo',
    },
    ENNA: {
        regionCode: 'EN',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Enna',
    },
    FERMO: {
        regionCode: 'FM',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Fermo',
    },
    FERRARA: {
        regionCode: 'FE',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Ferrara',
    },
    FIRENZE: {
        regionCode: 'FI',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Firenze',
    },
    FOGGIA: {
        regionCode: 'FG',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Foggia',
    },
    'FORLI-CESENA': {
        regionCode: 'FC',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Forli-cesena',
    },
    FROSINONE: {
        regionCode: 'FR',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Frosinone',
    },
    GENOVA: {
        regionCode: 'GE',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Genova',
    },
    GORIZIA: {
        regionCode: 'GO',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Gorizia',
    },
    GROSSETO: {
        regionCode: 'GR',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Grosseto',
    },
    IMPERIA: {
        regionCode: 'IM',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Imperia',
    },
    ISERNIA: {
        regionCode: 'IS',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Isernia',
    },
    'LA-SPEZIA': {
        regionCode: 'SP',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'La-spezia',
    },
    LATINA: {
        regionCode: 'LT',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Latina',
    },
    LECCE: {
        regionCode: 'LE',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Lecce',
    },
    LECCO: {
        regionCode: 'LC',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Lecco',
    },
    LIVORNO: {
        regionCode: 'LI',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Livorno',
    },
    LODI: {
        regionCode: 'LO',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Lodi',
    },
    LUCCA: {
        regionCode: 'LU',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Lucca',
    },
    MACERATA: {
        regionCode: 'MC',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Macerata',
    },
    MANTOVA: {
        regionCode: 'MN',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Mantova',
    },
    'MASSA-CARRARA': {
        regionCode: 'MS',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Massa-carrara',
    },
    MATERA: {
        regionCode: 'MT',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Matera',
    },
    'MEDIO CAMPIDANO': {
        regionCode: 'VS',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Medio Campidano',
    },
    MESSINA: {
        regionCode: 'ME',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Messina',
    },
    MILANO: {
        regionCode: 'MI',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Milano',
    },
    MODENA: {
        regionCode: 'MO',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Modena',
    },
    'MONZA-BRIANZA': {
        regionCode: 'MB',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Monza-brianza',
    },
    NAPOLI: {
        regionCode: 'NA',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Napoli',
    },
    NOVARA: {
        regionCode: 'NO',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Novara',
    },
    NUORO: {
        regionCode: 'NU',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Nuoro',
    },
    OGLIASTRA: {
        regionCode: 'OG',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Ogliastra',
    },
    'OLBIA TEMPIO': {
        regionCode: 'OT',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Olbia Tempio',
    },
    ORISTANO: {
        regionCode: 'OR',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Oristano',
    },
    PADOVA: {
        regionCode: 'PD',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Padova',
    },
    PALERMO: {
        regionCode: 'PA',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Palermo',
    },
    PARMA: {
        regionCode: 'PR',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Parma',
    },
    PAVIA: {
        regionCode: 'PV',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Pavia',
    },
    PERUGIA: {
        regionCode: 'PG',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Perugia',
    },
    'PESARO-URBINO': {
        regionCode: 'PU',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Pesaro-urbino',
    },
    PESCARA: {
        regionCode: 'PE',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Pescara',
    },
    PIACENZA: {
        regionCode: 'PC',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Piacenza',
    },
    PISA: {
        regionCode: 'PI',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Pisa',
    },
    PISTOIA: {
        regionCode: 'PT',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Pistoia',
    },
    PORDENONE: {
        regionCode: 'PN',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Pordenone',
    },
    POTENZA: {
        regionCode: 'PZ',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Potenza',
    },
    PRATO: {
        regionCode: 'PO',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Prato',
    },
    RAGUSA: {
        regionCode: 'RG',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Ragusa',
    },
    RAVENNA: {
        regionCode: 'RA',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Ravenna',
    },
    'REGGIO-CALABRIA': {
        regionCode: 'RC',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Reggio-calabria',
    },
    'REGGIO-EMILIA': {
        regionCode: 'RE',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Reggio-emilia',
    },
    RIETI: {
        regionCode: 'RI',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Rieti',
    },
    RIMINI: {
        regionCode: 'RN',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Rimini',
    },
    ROMA: {
        regionCode: 'Roma',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Roma',
    },
    ROVIGO: {
        regionCode: 'RO',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Rovigo',
    },
    SALERNO: {
        regionCode: 'SA',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Salerno',
    },
    SASSARI: {
        regionCode: 'SS',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Sassari',
    },
    SAVONA: {
        regionCode: 'SV',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Savona',
    },
    SIENA: {
        regionCode: 'SI',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Siena',
    },
    SIRACUSA: {
        regionCode: 'SR',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Siracusa',
    },
    SONDRIO: {
        regionCode: 'SO',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Sondrio',
    },
    TARANTO: {
        regionCode: 'TA',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Taranto',
    },
    TERAMO: {
        regionCode: 'TE',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Teramo',
    },
    TERNI: {
        regionCode: 'TR',
        paintLaborRate: 30,
        stripRefitLaborRate: 30,
        repairLaborRate: 30,
        displayLabel: 'Terni',
    },
    TORINO: {
        regionCode: 'TO',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Torino',
    },
    TRAPANI: {
        regionCode: 'TP',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Trapani',
    },
    TRENTO: {
        regionCode: 'TN',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Trento',
    },
    TREVISO: {
        regionCode: 'TV',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Treviso',
    },
    TRIESTE: {
        regionCode: 'TS',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Trieste',
    },
    UDINE: {
        regionCode: 'UD',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Udine',
    },
    VARESE: {
        regionCode: 'VA',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Varese',
    },
    VENEZIA: {
        regionCode: 'VE',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Venezia',
    },
    VERBANIA: {
        regionCode: 'VB',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Verbania',
    },
    VERCELLI: {
        regionCode: 'VC',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Vercelli',
    },
    VERONA: {
        regionCode: 'VR',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Verona',
    },
    'VIBO-VALENTIA': {
        regionCode: 'VV',
        paintLaborRate: 26,
        stripRefitLaborRate: 26,
        repairLaborRate: 26,
        displayLabel: 'Vibo-valentia',
    },
    VICENZA: {
        regionCode: 'VI',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Vicenza',
    },
    VITERBO: {
        regionCode: 'VT',
        paintLaborRate: 34,
        stripRefitLaborRate: 34,
        repairLaborRate: 34,
        displayLabel: 'Viterbo',
    },
};
//# sourceMappingURL=assimoco.js.map